import { useDocumentTitle } from "../../../use-document-title";
import { QaAutomationCharts } from "./charts";
import { QaAutomationHeaderAndStats } from "./header-and-stats";
import styles from "./index.module.css";
import { QaAutomationRecentRuns } from "./recent-runs";

/**
 * `/admin/qa-automation` — QA automation dashboard.
 *
 * Composes the three sibling slices built for this page into one route:
 * - `QaAutomationHeaderAndStats` — date-range tabs, "Start new run", the
 *   next-scheduled-run / runs-in-progress info cards, and the four KPI cards.
 * - `QaAutomationCharts` — "Verdict trend" and "Average run duration".
 * - `QaAutomationRecentRuns` — "5 slowest tests" / "Tests with the highest
 *   failure rate" ranked cards, plus the "Recent runs" table + pagination.
 *
 * Wrapped in the same page-level container/spacing convention as
 * `../../home.tsx` / `../../stub-page.tsx` (32px page padding). Unlike
 * those, this page has real custom content, so it doesn't use
 * `<StubPage>` — it calls `useDocumentTitle` directly instead. There is no
 * on-page `<h1>` here: the app shell's breadcrumb trail already reads
 * "QA Automation" for this route, so a duplicate page-level heading would
 * be redundant. `QaAutomationHeaderAndStats` also publishes the date-range
 * tab bar + "Start new run" action into the shell's secondary-header slot
 * rather than rendering them in the page body.
 *
 * All data rendered here is static mock data owned by the child components —
 * there is no live QA-run backend wired into `platform/` yet.
 */
export function AdminQaAutomationPage() {
  useDocumentTitle("QA Automation");

  return (
    <div className={styles.page}>
      <QaAutomationHeaderAndStats />
      <QaAutomationCharts />
      <QaAutomationRecentRuns />
    </div>
  );
}
